import { memo, useMemo } from "react";
import ModularNavBar from "src/components/ModularNavBar";
import { useGatheringStore } from "src/contexts/GatheringContext";
import useHamburgerNav from "src/hooks/useHamburgerNav";
import { FixedPosition } from "src/styles/position";
import CreateModeGatheringHomeNavBarContent from "./components/CreateModeGatheringHomeNavBarContent";
import DefaultGatheringHomeNavBarContent from "./components/DefaultGatheringHomeNavBarContent";
import EditModeGatheringHomeNavBarContent from "./components/EditModeGatheringHomeNavBarContent";
import MiscPhotoViewsGatheringHomeNavBarContent from "./components/MiscPhotoViewsGatheringHomeNavBarContent";
import SelectModeGatheringHomeNavBarContent from "./components/SelectModeGatheringHomeNavBarContent";

const GatheringHomeNavBar = ({}: {}) => {
	const editMode = useGatheringStore((state) => state.editMode);
	const selectMode = useGatheringStore((state) => state.selectMode);
	const viewMode = useGatheringStore((state) => state.viewMode);

	const shouldShowHamburger = useMemo(
		() =>
			editMode === "None" &&
			selectMode === "None" &&
			viewMode !== "AllCaller" &&
			viewMode !== "Hidden",
		[editMode, selectMode, viewMode],
	); // don't show hamburger menu when in edit or select mode
	useHamburgerNav(shouldShowHamburger);

	return (
		<ModularNavBar
			style={{
				position: FixedPosition,
			}}
			renderItem={() => {
				if (selectMode === "Select") {
					return {
						Content: <SelectModeGatheringHomeNavBarContent />,
						key: "Share",
					};
				}
				if (editMode === "Create") {
					return {
						Content: <CreateModeGatheringHomeNavBarContent />,
						key: "Create",
					};
				}
				if (editMode === "Edit") {
					return {
						Content: <EditModeGatheringHomeNavBarContent />,
						key: "Edit",
					};
				}
				if (viewMode === "AllCaller") {
					return {
						Content: <MiscPhotoViewsGatheringHomeNavBarContent title="Your uploads" />,
						key: "AllCaller",
					};
				}
				if (viewMode === "Hidden") {
					return {
						Content: <MiscPhotoViewsGatheringHomeNavBarContent title="Hidden" />,
						key: "Hidden",
					};
				}
				return {
					Content: <DefaultGatheringHomeNavBarContent />,
					key: "Default",
				};
			}}
		/>
	);
};
export default memo(GatheringHomeNavBar);
